module.exports = __webpack_public_path__ + "img/safari-btn-icon.09258bc5.svg";